// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3pd5u","upload":"Small_upload__1JeHF","imageWrap":"Small_imageWrap__3Me26","removeBtn":"Small_removeBtn__33Yky"};